import { PencilLine, Plus } from 'lucide-angular';
import { MenuAction } from '@shared/interfaces/header/menu-action';

export const actorRegisterListMenu: MenuAction[] = [
  {
    id: 'create',
    title: 'common.create',
    icon: Plus
  },
  {
    id: 'edit',
    title: 'common.edit',
    icon: PencilLine
  }
]
